import { useEffect, useState } from 'react';
import Modal from './ui/Modal.jsx';
import { pb } from '../lib/pocketbase.js';
import { useAuth } from '../auth/AuthContext.jsx';

const EMPTY = {
  name: '',
  rolle: '',
  email: '',
  telefon: '',
  notiz: '',
};

// Anlegen und Bearbeiten eines Ansprechpartners für einen Partner.
// Sensible Daten — die aufrufende Card ist bereits Admin/GF-geschützt,
// zusätzlich greifen die PB-Rules auf partner_ansprechpartner.
export default function AnsprechpartnerFormModal({
  open,
  onClose,
  onSaved,
  partnerId,
  ansprechpartner,
}) {
  const { user } = useAuth();
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setForm(ansprechpartner ? { ...EMPTY, ...ansprechpartner } : EMPTY);
    setError(null);
  }, [open, ansprechpartner]);

  function handleChange(field) {
    return (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const payload = {
        partner: partnerId,
        name: form.name,
        rolle: form.rolle,
        email: form.email,
        telefon: form.telefon,
        notiz: form.notiz,
      };
      let saved;
      if (ansprechpartner?.id) {
        saved = await pb.collection('partner_ansprechpartner').update(ansprechpartner.id, payload);
      } else {
        payload.angelegt_von = user?.id ?? null;
        saved = await pb.collection('partner_ansprechpartner').create(payload);
      }
      onSaved?.(saved);
      onClose();
    } catch (err) {
      setError(err?.message || 'Speichern fehlgeschlagen.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={ansprechpartner?.id ? 'Ansprechpartner bearbeiten' : 'Ansprechpartner hinzufügen'}
      size="lg"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="sm:col-span-2">
            <label className="label">Name *</label>
            <input
              type="text"
              required
              className="input mt-1"
              value={form.name}
              onChange={handleChange('name')}
            />
          </div>

          <div>
            <label className="label">Rolle</label>
            <input
              type="text"
              className="input mt-1"
              placeholder="z. B. Account Manager, IT"
              value={form.rolle}
              onChange={handleChange('rolle')}
            />
          </div>

          <div>
            <label className="label">Telefon</label>
            <input
              type="tel"
              className="input mt-1"
              value={form.telefon}
              onChange={handleChange('telefon')}
            />
          </div>

          <div className="sm:col-span-2">
            <label className="label">E-Mail</label>
            <input
              type="email"
              className="input mt-1"
              value={form.email}
              onChange={handleChange('email')}
            />
          </div>

          <div className="sm:col-span-2">
            <label className="label">Notiz</label>
            <textarea
              rows={4}
              className="input mt-1"
              value={form.notiz}
              onChange={handleChange('notiz')}
            />
          </div>
        </div>

        {error && (
          <div className="rounded-md bg-red-50 p-3 text-sm text-red-700 ring-1 ring-red-200">
            {error}
          </div>
        )}

        <div className="sticky bottom-0 -mx-6 -mb-5 mt-6 flex justify-end gap-2 border-t border-slate-200 bg-white px-6 py-4">
          <button type="button" className="btn-secondary" onClick={onClose} disabled={saving}>
            Abbrechen
          </button>
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? 'Speichern …' : 'Speichern'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
